export const RESET = 'validated/RESET';
export const START = 'validated/START';
export const SUCCESS = 'validated/SUCCESS';
export const ERROR = 'validated/ERROR';
